import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { BasePageComponent } from 'src/app/shared/components/base/base-page.component';
import { JobModel } from 'src/app/shared/models/domain/job.model';
import { DialogService } from 'src/app/core/services/domain/dialog.service';
import { MessagesGridComponent } from 'src/app/shared/components/grids/messages-grid/messages-grid.component';
import { MessageModel } from 'src/app/shared/models/domain/message.model';

@Component({
  selector: 'app-business-page',
  templateUrl: './messages-page.component.html',
  styleUrls: ['./messages-page.component.scss']
})
export class MessagesPageComponent extends BasePageComponent implements OnInit {
  @ViewChild('messagesGrid') messagesGrid: MessagesGridComponent;


  constructor(
    private router: Router,
    private dialogService: DialogService) {
    super();
  }

  ngOnInit(): void {
  }

  onRowClicked(data: { data: MessageModel, event: any }): void {
    let matDialogRef = this.dialogService.openMessage(data.data.messageKey);

    matDialogRef.afterClosed().subscribe(result => {
      this.messagesGrid.refreshGridData().subscribe();
    });
  }

  onAddButtonClicked(): void {
    let matDialogRef = this.dialogService.openMessage(null);

    matDialogRef.afterClosed().subscribe(result => {
      this.messagesGrid.refreshGridData().subscribe();
    });
  }
}
